import axios from 'axios'

const base = window._env_.VUE_APP_AUTH_HOST

export const login = params => {
  const promise = http.post(`${base}/login`, params)
  promise.disableAuth = true
  return promise
}
export const logout = params => {
  return http.post(`${base}/logout`, params)
}
export const getMe = params => {
  // 添加 cancelToken，使切换路由时不被取消请求
  return http.get(`${base}/me`, {
    params,
    cancelToken: axios.CancelToken.source().token,
  })
}
export const refresh = params => {
  return http.post(`${base}/refresh`, params)
}
export const modifyPassword = params => {
  return http.patch(`${base}/password`, params)
}

export const register = params => {
  return http.post(`${base}/register`, params)
}
